/* Review Ticker — buy-box social proof block.
   Rotates review excerpts (paused on hover, off-screen, and for
   reduced-motion users) and smooth-scrolls to the Social proof section
   when clicked. */

if (!window.customElements.get('review-ticker')) {
  class ReviewTicker extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-ticker-item]'));
      this.avatars = Array.from(this.querySelectorAll('[data-ticker-avatar]'));
      this.index = 0;
      this.paused = false;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.syncAvatars();
      this.setupRotation();
      this.setupScroll();
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
      if (this.io) this.io.disconnect();
    }

    setupRotation() {
      if (this.items.length < 2 || this.reducedMotion) return;

      const seconds = Math.max(2, parseInt(this.dataset.interval, 10) || 4);

      this.addEventListener('pointerenter', () => { this.paused = true; });
      this.addEventListener('pointerleave', () => { this.paused = false; });
      this.addEventListener('focusin', () => { this.paused = true; });
      this.addEventListener('focusout', () => { this.paused = false; });

      this.inView = true;
      this.io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => { this.inView = entry.isIntersecting; });
      });
      this.io.observe(this);

      this.timer = setInterval(() => {
        if (this.paused || !this.inView || document.hidden) return;
        this.next();
      }, seconds * 1000);
    }

    next() {
      const current = this.items[this.index];
      this.index = (this.index + 1) % this.items.length;
      const upcoming = this.items[this.index];

      current.classList.remove('is-active');
      current.classList.add('is-leaving');
      current.setAttribute('aria-hidden', 'true');
      setTimeout(() => current.classList.remove('is-leaving'), 450);

      upcoming.classList.add('is-active');
      upcoming.removeAttribute('aria-hidden');

      this.syncAvatars();
    }

    syncAvatars() {
      this.avatars.forEach((avatar, i) => {
        avatar.classList.toggle('is-active', i === this.index);
      });
    }

    setupScroll() {
      const inner = this.querySelector('.review-ticker__inner');
      if (!inner) return;

      inner.addEventListener('click', () => {
        let target = null;

        if (this.dataset.anchor) {
          target = document.getElementById(this.dataset.anchor);
        }
        if (!target) {
          target = document.querySelector('.shopify-section--social-proof');
        }
        if (!target) return;

        if (!target.style.scrollMarginBlockStart) {
          target.style.scrollMarginBlockStart = 'calc(var(--sticky-area-height, 0px) + 1rem)';
        }

        target.scrollIntoView({
          behavior: this.reducedMotion ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    }
  }

  window.customElements.define('review-ticker', ReviewTicker);
}
